export const GENERAL_PROPERTIES = {
    HIDE_IF_CONDITION: 'HideIfCondition',
    READ_ONLY: 'ReadOnly',
    HYPERLINK: 'Hyperlink',
}